export default __webpack_public_path__ + "static/media/ensuite1.74bc0aad.jpg";